import { Box, Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { Menu, MenuItem, SidebarContent, SidebarFooter, SidebarHeader } from "react-pro-sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import keydriveLogo from '../../../assets/svg/keydrive__logo.svg';
import KeydriveLogoCollapsed from '../../../assets/svg/keydrive_collapsed.svg';
import KeydriveLogoCollapsedAdmin from '../../../assets/svg/keydrive_collapsed_admin.svg';
import keydriveLogoAdmin from '../../../assets/svg/keydrive_logo_admin.svg';
import '../../Sidebar/Prosidebar.css';
import { ContentSideChoicer } from "./ContentSideChoicer";
import { ContentSideComp, ContentbarProps, ISelectList } from "./ContentSideComp";
import { ContentSideCompSelectField } from "./ContentSideCompSelectField";


interface ContentSideListProps {
    contentList: ContentbarProps<ISelectList>[];
    isCollapsed: boolean;
    nameOrg: string;
    isAdminConsolePage: boolean;
}

export enum CurrentPage {
    NONE = "NONE",
    HOME = "HOME",
    DASHBOARD = "DASHBOARD",
    FEED = "FEED",
    PENDENCIES = "PENDENCIES",
    DOCUMENTS = "DOCUMENTS",
    VALIDATIONRULES = "VALIDATIONRULES",
    SHAREDITEM = "SHAREDITEM",
    TEMPORALITY = "TEMPORALITY",
    ADMIN = "ADMIN",
    PREFERENCES = "PREFERENCES", 
    USERS_AND_GROUPS = "USERS_AND_GROUPS",
    WORKSPACE = "WORKSPACE",
    ACCOUNTANDSUBSCRIPTION = "ACCOUNT_AND_SUBSCRIPTION" ,
    RECICLE_BIN = "RECICLE_BIN",
    QUICK_ACCESS = "QUICK_ACCESS",
    PLANS = "PLANS",
    PRIVILEGES = "PRIVILEGES",
    ORGANIZATION = "ORGANIZATION"
}

export const ContentSideList: React.FC<ContentSideListProps> = ({ contentList, isCollapsed, nameOrg, isAdminConsolePage }: ContentSideListProps) => {
    const [currentPage, setCurrentPage] = useState<CurrentPage>(CurrentPage.NONE);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname == "/") {
            setCurrentPage(CurrentPage.HOME)
        } else if (location.pathname.includes("dashboard")) {
            setCurrentPage(CurrentPage.DASHBOARD)
        } else if (location.pathname.toLocaleLowerCase().includes("organizations")) {
            setCurrentPage(CurrentPage.ORGANIZATION)
        } else if (location.pathname.includes("plans")) {
            setCurrentPage(CurrentPage.PLANS);
        } else if (location.pathname.includes("adminConsole/config")) {
            setCurrentPage(CurrentPage.PREFERENCES)
        } else if (location.pathname.includes("Permission")) {
            setCurrentPage(CurrentPage.PRIVILEGES);
        } else if (location.pathname.includes("Item/tracker")) {
            setCurrentPage(CurrentPage.FEED)
        } else if (location.pathname.includes("UserPendencies")) {
            setCurrentPage(CurrentPage.PENDENCIES)
        } else if (location.pathname.includes("documentTypes")) {
            setCurrentPage(CurrentPage.DOCUMENTS)
        } else if (location.pathname.includes("validationRule")) {
            setCurrentPage(CurrentPage.VALIDATIONRULES)
        } else if (location.pathname.includes("temporality")) {
            setCurrentPage(CurrentPage.TEMPORALITY)
        } else if (location.pathname.includes("usersAndGroups")) {
            setCurrentPage(CurrentPage.USERS_AND_GROUPS)
        } else if (location.pathname.includes("adminConsole/workspaces")) {
            setCurrentPage(CurrentPage.WORKSPACE)
        } else if (location.pathname.includes("adminConsole/accountAndSubscription")) {
            setCurrentPage(CurrentPage.ACCOUNTANDSUBSCRIPTION)
        } else if (location.pathname.includes("adminConsole")) {
            setCurrentPage(CurrentPage.ADMIN)
        } else if (location.pathname.includes("wsallowed")) {
            setCurrentPage(CurrentPage.DOCUMENTS) 
        } else if (location.pathname.includes("recycleBin")) {
            setCurrentPage(CurrentPage.RECICLE_BIN)
        } else if (location.pathname.includes("SharedItem")) {
            setCurrentPage(CurrentPage.SHAREDITEM)
        } else if (location.pathname.includes("preferences")) {
            setCurrentPage(CurrentPage.PREFERENCES)
        } else if (location.pathname.includes(nameOrg)) {
            setCurrentPage(CurrentPage.HOME)
        } else {
            setCurrentPage(CurrentPage.NONE)
        }
    }, [location])

    return (
        <>
            <SidebarHeader style={{
                height: "66px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Menu>
                    <MenuItem onClick={() => navigate("/")}>
                        {!isCollapsed ? (
                            isAdminConsolePage ? (
                                <Box sx={{
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}>
                                    <Box component="img" src={keydriveLogoAdmin} />
                                    <Chip label="ADMIN" size="small" sx={{
                                        backgroundColor: "#2B3454",
                                        color: "white",
                                    }} />
                                </Box>
                            ) : (
                                <Box component="img" src={keydriveLogo} />
                            )
                        ) : (
                            <Box component="img" src={isAdminConsolePage ? KeydriveLogoCollapsedAdmin : KeydriveLogoCollapsed} />
                        )}
                    </MenuItem>
                </Menu>
            </SidebarHeader>
            <SidebarContent>
                <Menu className={currentPage == CurrentPage.HOME ? "none" : ""}>
                    {contentList.filter(content => content.footer !== true).map((content, index) => (
                        <ContentSideChoicer
                            NormalSidebarComponent={ContentSideComp}
                            SelectSidebarComponent={ContentSideCompSelectField}
                            RenderComponentCriteria={content.isSelectField!}
                            content={content}
                            isCurrentPage={currentPage == content.currentPage && currentPage != CurrentPage.NONE}
                            isAdminConsolePage={isAdminConsolePage}
                            ExternalProps={{
                                index,
                                isCollapsed: isCollapsed,
                                nameOrg: nameOrg!
                            }}
                        />
                    ))}
                </Menu>
            </SidebarContent>
            <SidebarFooter>
                <Menu>
                    {contentList.filter(content => content.footer === true).map((content, index) => (
                        <ContentSideChoicer
                            NormalSidebarComponent={ContentSideComp}
                            SelectSidebarComponent={ContentSideCompSelectField}
                            RenderComponentCriteria={content.isSelectField!}
                            content={content}
                            isCurrentPage={currentPage == content.currentPage && currentPage != CurrentPage.NONE}
                            isAdminConsolePage={isAdminConsolePage}
                            ExternalProps={{
                                index,
                                isCollapsed: isCollapsed,
                                nameOrg: nameOrg!
                            }}
                        />
                    ))}
                </Menu>
            </SidebarFooter>
        </>
    )
}

export default ContentSideList